import type { Theme } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { palette } from '@mui/system';

export default makeStyles((theme: Theme) =>
  createStyles({
    circleInner: {
      height: 40,
      width: 40
    },
    marginTop: {
      marginTop: 16
    },

    addBtn: {
      color: theme.palette.primary[950]
    },
    iconMWidth24: {
      minWidth: 24
    },
    paddingRight10: {
      paddingRight: 10
    }
  })
);
